module.exports = __webpack_public_path__ + "res/12-img_game_text_r.5e42d1bd6c28bdd13ed98edbdc25d8b6.png";